import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd" transform="translate(2)">
      <path className="euiIcon__fillNegative" d="M0,16 C0,17.384 0.194,18.72 0.524,20 L20,20 C22.209,20 24,18.209 24,16 C24,13.791 22.209,12 20,12 L0.524,12 C0.194,13.28 0,14.616 0,16"/>
      <path fill="#FEC514" d="M26.9238,7.6621 C27.4828,7.1461 28.0028,6.5931 28.4798,6.0001 C25.5468,2.3461 21.0498,0.0001 15.9998,0.0001 C9.6788,0.0001 4.2388,3.6781 1.6438,9.0001 L23.5108,9.0001 C24.7768,9.0001 25.9938,8.5191 26.9238,7.6621"/>
      <path fill="#00BFB3" d="M23.5107,23 L1.6437,23 C4.2397,28.323 9.6787,32 15.9997,32 C21.0497,32 25.5467,29.654 28.4797,26 C28.0027,25.407 27.4827,24.854 26.9237,24.338 C25.9937,23.48 24.7767,23 23.5107,23"/>
    </g>
  </svg>
);
